module.exports = __webpack_public_path__ + "img/gno.1b1f4dea.svg";